import Vue from "vue"
import Router from "vue-router"
import GrantWritingNeedsAssessment from "@/components/public/grant-writing-needs-assessment"
import GrantWritingTraining from "@/components/public/grant-writing-training-application"
import JndArticle from "@/components/public/jnd-article"
import JndArticleConference2024Reviewers from "@/components/public/jnd-article-assessment-reviewers"
import JndArticleConference2024Upload from "@/components/public/jnd-article-assessment-upload"
import JndArticleConference2024Edit from "@/components/public/jnd-article-assessment-edit"
import JndArticleConference2024Review from "@/components/public/jnd-article-assessment-review"
import NotFound from "@/views/global/404"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/grant-writing-needs-assessment",
      name: "grant-writing-needs-assessment",
      component: GrantWritingNeedsAssessment
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/grant-writing-training-attendance-register",
      name: "grant-writing-training",
      component: GrantWritingTraining
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/jnd-article/10.57039/:id",
      name: "jnd-article",
      component: JndArticle
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/jnd-article/conference/2024/reviewers",
      name: "jnd-article-conference-2024-reviewers",
      component: JndArticleConference2024Reviewers
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/jnd-article/conference/2024-review/:token",
      name: "jnd-article-conference-2024-review",
      component: JndArticleConference2024Review
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/jnd-article/conference/2024/edit/:id",
      name: "jnd-article-conference-2024-edit",
      component: JndArticleConference2024Edit
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "/jnd-article/conference/2024/upload",
      name: "jnd-article-conference-2024-upload",
      component: JndArticleConference2024Upload
      /*meta: {
        forVisitors: true
      }*/
    },
    {
      path: "*",
      name: "not-found",
      component: NotFound
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js